import http from "api/https";

export const getmynotifications = (): Promise<any> => {
  return http.get(`/notification/GetMyNotifications`);
};

export const clearNotifications = (email: string): Promise<any> => {
    return http.post(`/notification/ClearNotifications`, { email: email });
};

export const clearNotification = (id: number): Promise<any> => {
    return http.post(`/notification/ClearNotification`, { id: id });
};